import React from 'react';
import { Box, Card, CardContent, Typography, LinearProgress, Chip, useTheme } from '@mui/material';
import { AccountBalanceWallet as WalletIcon } from '@mui/icons-material';
import { WhiteLabelCreditInfo } from '../types';

interface WhiteLabelCreditInfoProps {
    creditInfo: WhiteLabelCreditInfo;
}

const WhiteLabelCreditInfoComponent: React.FC<WhiteLabelCreditInfoProps> = ({ creditInfo }) => {
    const theme = useTheme();
    const percentage = (creditInfo.usedCredits / creditInfo.maxCredits) * 100;
    const isNearLimit = percentage >= 80;
    const isAtLimit = percentage >= 100;

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <WalletIcon color="primary" />
                    <Typography variant="h6">Créditos Mensais</Typography>
                    <Chip
                        sx={{ color: theme.palette.mode === 'dark' ? '#000' : undefined }}
                        label={`${creditInfo.availableCredits.toLocaleString()} disponíveis`}
                        color={isAtLimit ? 'error' : isNearLimit ? 'warning' : 'success'}
                        size="small"
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            Usados: {creditInfo.usedCredits.toLocaleString()}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Total: {creditInfo.maxCredits.toLocaleString()}
                        </Typography>
                    </Box>

                    <LinearProgress
                        variant="determinate"
                        value={percentage}
                        color={isAtLimit ? 'error' : isNearLimit ? 'warning' : 'primary'}
                        sx={{ height: 8, borderRadius: 4 }}
                    />
                </Box>

                {isNearLimit && (
                    <Typography
                        variant="body2"
                        color={isAtLimit ? 'error' : 'warning.main'}
                        sx={{ fontStyle: 'italic' }}
                    >
                        {isAtLimit
                            ? 'Você atingiu o limite máximo de créditos mensais'
                            : 'Você está próximo do limite de créditos mensais'
                        }
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default WhiteLabelCreditInfoComponent;
